// Build a srcset (1x, 2x, 3x) from pre-imported image URLs for dashing-ui banner components.
export function srcSet(img1x: string, img2x: string, img3x: string): string[] {
  return [`${img1x} 1x`, `${img2x} 2x`, `${img3x} 3x`];
}

export function srcSetString(img1x: string, img2x: string, img3x: string): string {
  return srcSet(img1x, img2x, img3x).join(', ');
}
